import Cookies from "js-cookie";

export default function storeGetUserIdentifier(): string {
    return Cookies.get("ajs_user_id") ||
        Cookies.get("ajs_anonymous_id") ||
        Cookies.get("_cioanonid");
}
